<template>
    <div id="needReviewComponent" v-if="currentUser">
        <div class="modal need_review_modal" id="needReviewModal" tabindex="-1" role="dialog"
             aria-labelledby="needReviewModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <template v-if="!success && currentUser.need_review">
                            <img class="modal-logo" src="/assets/images/svg/cat.svg" alt="">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.0656738" y="10.9271" width="15.3623" height="1.5173" rx="0.758649" transform="rotate(-45 0.0656738 10.9271)" fill="#929292"/>
                                        <rect y="1.07288" width="1.5173" height="15.3623" rx="0.758649" transform="rotate(-45 0 1.07288)" fill="#929292"/>
                                    </svg>
                                </span>
                            </button>
                            <div class="title">{{$store.getters.t('need_contractor_review_modal_rate_service')}} «{{ currentUser.need_review.name }}»</div>
                            <div class="review-marks">
                                <div class="review-mark" :class="{'review-mark-active': mark === 1}" @click="mark = 1">
                                    <svg width="64" height="54" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(0.901501 -0.432778 0.440223 0.897889 10.0556 26.1252)"/>
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(-0.901501 -0.432778 -0.440223 0.897889 53.9444 26.0263)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(-0.964447 -0.264275 -0.269497 0.963001 41.4742 11.5015)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(0.964447 -0.264275 0.269497 0.963001 22.3109 11.3796)"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M40.7327 29.0746C40.4084 28.5346 40.1161 28.0479 39.8384 27.6632C38.0803 25.0204 35.1042 23.283 31.7289 23.283C27.5504 23.283 23.9838 25.9456 22.5822 29.6924C21.3677 32.1325 20.3462 33.3449 18.3087 34.4238C17.9225 34.579 17.5484 34.7591 17.1882 34.9622C14.1949 36.6501 12.165 39.925 12.165 43.6883C12.165 49.1785 16.4854 53.7601 21.8148 53.7601C21.9293 53.7601 22.0371 53.7601 22.1538 53.7579L24.5197 53.7427C25.3976 53.6018 26.1766 53.2848 27.0728 52.9008C28.5756 52.2569 30.2573 51.5364 31.9388 51.5364C32.0044 51.5364 32.0698 51.5372 32.135 51.5388C32.2002 51.5372 32.2656 51.5364 32.3312 51.5364C34.0126 51.5364 35.6944 52.2569 37.1972 52.9008C37.9287 53.2142 38.5822 53.4831 39.2751 53.6479L42.1717 53.6293C47.5011 53.6293 51.8215 49.1785 51.8215 43.6883C51.8215 39.7074 49.5501 36.273 46.2696 34.6855C46.0435 34.5761 45.8127 34.4755 45.5775 34.3841C43.2095 33.1987 41.7986 30.8494 40.7327 29.0746L40.7327 29.0746Z"/>
                                    </svg>
                                    <div class="review-mark-name">{{$store.getters.t('need_contractor_review_modal_bad')}}</div>
                                </div>
                                <div class="review-mark" :class="{'review-mark-active': mark === 2}" @click="mark = 2">
                                    <svg width="64" height="54" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(0.901501 -0.432778 0.440223 0.897889 10.0556 26.1252)"/>
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(-0.901501 -0.432778 -0.440223 0.897889 53.9444 26.0263)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(-0.964447 -0.264275 -0.269497 0.963001 41.4742 11.5015)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(0.964447 -0.264275 0.269497 0.963001 22.3109 11.3796)"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M40.7327 29.0746C40.4084 28.5346 40.1161 28.0479 39.8384 27.6632C38.0803 25.0204 35.1042 23.283 31.7289 23.283C27.5504 23.283 23.9838 25.9456 22.5822 29.6924C21.3677 32.1325 20.3462 33.3449 18.3087 34.4238C17.9225 34.579 17.5484 34.7591 17.1882 34.9622C14.1949 36.6501 12.165 39.925 12.165 43.6883C12.165 49.1785 16.4854 53.7601 21.8148 53.7601C21.9293 53.7601 22.0371 53.7601 22.1538 53.7579L24.5197 53.7427C25.3976 53.6018 26.1766 53.2848 27.0728 52.9008C28.5756 52.2569 30.2573 51.5364 31.9388 51.5364C32.0044 51.5364 32.0698 51.5372 32.135 51.5388C32.2002 51.5372 32.2656 51.5364 32.3312 51.5364C34.0126 51.5364 35.6944 52.2569 37.1972 52.9008C37.9287 53.2142 38.5822 53.4831 39.2751 53.6479L42.1717 53.6293C47.5011 53.6293 51.8215 49.1785 51.8215 43.6883C51.8215 39.7074 49.5501 36.273 46.2696 34.6855C46.0435 34.5761 45.8127 34.4755 45.5775 34.3841C43.2095 33.1987 41.7986 30.8494 40.7327 29.0746L40.7327 29.0746Z"/>
                                    </svg>
                                    <div class="review-mark-name">{{$store.getters.t('need_contractor_review_modal_so_so')}}</div>
                                </div>
                                <div class="review-mark" :class="{'review-mark-active': mark === 3}" @click="mark = 3">
                                    <svg width="64" height="54" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(0.901501 -0.432778 0.440223 0.897889 10.0556 26.1252)"/>
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(-0.901501 -0.432778 -0.440223 0.897889 53.9444 26.0263)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(-0.964447 -0.264275 -0.269497 0.963001 41.4742 11.5015)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(0.964447 -0.264275 0.269497 0.963001 22.3109 11.3796)"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M40.7327 29.0746C40.4084 28.5346 40.1161 28.0479 39.8384 27.6632C38.0803 25.0204 35.1042 23.283 31.7289 23.283C27.5504 23.283 23.9838 25.9456 22.5822 29.6924C21.3677 32.1325 20.3462 33.3449 18.3087 34.4238C17.9225 34.579 17.5484 34.7591 17.1882 34.9622C14.1949 36.6501 12.165 39.925 12.165 43.6883C12.165 49.1785 16.4854 53.7601 21.8148 53.7601C21.9293 53.7601 22.0371 53.7601 22.1538 53.7579L24.5197 53.7427C25.3976 53.6018 26.1766 53.2848 27.0728 52.9008C28.5756 52.2569 30.2573 51.5364 31.9388 51.5364C32.0044 51.5364 32.0698 51.5372 32.135 51.5388C32.2002 51.5372 32.2656 51.5364 32.3312 51.5364C34.0126 51.5364 35.6944 52.2569 37.1972 52.9008C37.9287 53.2142 38.5822 53.4831 39.2751 53.6479L42.1717 53.6293C47.5011 53.6293 51.8215 49.1785 51.8215 43.6883C51.8215 39.7074 49.5501 36.273 46.2696 34.6855C46.0435 34.5761 45.8127 34.4755 45.5775 34.3841C43.2095 33.1987 41.7986 30.8494 40.7327 29.0746L40.7327 29.0746Z"/>
                                    </svg>
                                    <div class="review-mark-name">{{$store.getters.t('need_contractor_review_modal_ok')}}</div>
                                </div>
                                <div class="review-mark" :class="{'review-mark-active': mark === 4}" @click="mark = 4">
                                    <svg width="64" height="54" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(0.901501 -0.432778 0.440223 0.897889 10.0556 26.1252)"/>
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(-0.901501 -0.432778 -0.440223 0.897889 53.9444 26.0263)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(-0.964447 -0.264275 -0.269497 0.963001 41.4742 11.5015)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(0.964447 -0.264275 0.269497 0.963001 22.3109 11.3796)"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M40.7327 29.0746C40.4084 28.5346 40.1161 28.0479 39.8384 27.6632C38.0803 25.0204 35.1042 23.283 31.7289 23.283C27.5504 23.283 23.9838 25.9456 22.5822 29.6924C21.3677 32.1325 20.3462 33.3449 18.3087 34.4238C17.9225 34.579 17.5484 34.7591 17.1882 34.9622C14.1949 36.6501 12.165 39.925 12.165 43.6883C12.165 49.1785 16.4854 53.7601 21.8148 53.7601C21.9293 53.7601 22.0371 53.7601 22.1538 53.7579L24.5197 53.7427C25.3976 53.6018 26.1766 53.2848 27.0728 52.9008C28.5756 52.2569 30.2573 51.5364 31.9388 51.5364C32.0044 51.5364 32.0698 51.5372 32.135 51.5388C32.2002 51.5372 32.2656 51.5364 32.3312 51.5364C34.0126 51.5364 35.6944 52.2569 37.1972 52.9008C37.9287 53.2142 38.5822 53.4831 39.2751 53.6479L42.1717 53.6293C47.5011 53.6293 51.8215 49.1785 51.8215 43.6883C51.8215 39.7074 49.5501 36.273 46.2696 34.6855C46.0435 34.5761 45.8127 34.4755 45.5775 34.3841C43.2095 33.1987 41.7986 30.8494 40.7327 29.0746L40.7327 29.0746Z"/>
                                    </svg>
                                    <div class="review-mark-name">{{$store.getters.t('need_contractor_review_modal_good')}}</div>
                                </div>
                                <div class="review-mark" :class="{'review-mark-active': mark === 5}" @click="mark = 5">
                                    <svg width="64" height="54" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(0.901501 -0.432778 0.440223 0.897889 10.0556 26.1252)"/>
                                        <ellipse rx="6.68246" ry="9.15746" transform="matrix(-0.901501 -0.432778 -0.440223 0.897889 53.9444 26.0263)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(-0.964447 -0.264275 -0.269497 0.963001 41.4742 11.5015)"/>
                                        <ellipse rx="7.22499" ry="9.83403" transform="matrix(0.964447 -0.264275 0.269497 0.963001 22.3109 11.3796)"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M40.7327 29.0746C40.4084 28.5346 40.1161 28.0479 39.8384 27.6632C38.0803 25.0204 35.1042 23.283 31.7289 23.283C27.5504 23.283 23.9838 25.9456 22.5822 29.6924C21.3677 32.1325 20.3462 33.3449 18.3087 34.4238C17.9225 34.579 17.5484 34.7591 17.1882 34.9622C14.1949 36.6501 12.165 39.925 12.165 43.6883C12.165 49.1785 16.4854 53.7601 21.8148 53.7601C21.9293 53.7601 22.0371 53.7601 22.1538 53.7579L24.5197 53.7427C25.3976 53.6018 26.1766 53.2848 27.0728 52.9008C28.5756 52.2569 30.2573 51.5364 31.9388 51.5364C32.0044 51.5364 32.0698 51.5372 32.135 51.5388C32.2002 51.5372 32.2656 51.5364 32.3312 51.5364C34.0126 51.5364 35.6944 52.2569 37.1972 52.9008C37.9287 53.2142 38.5822 53.4831 39.2751 53.6479L42.1717 53.6293C47.5011 53.6293 51.8215 49.1785 51.8215 43.6883C51.8215 39.7074 49.5501 36.273 46.2696 34.6855C46.0435 34.5761 45.8127 34.4755 45.5775 34.3841C43.2095 33.1987 41.7986 30.8494 40.7327 29.0746L40.7327 29.0746Z"/>
                                    </svg>
                                    <div class="review-mark-name">{{$store.getters.t('need_contractor_review_modal_excellent')}}</div>
                                </div>
                            </div>
                            <div class="text-danger" v-if="$v.mark.$error">{{$store.getters.t('need_contractor_review_modal_select_rating')}}</div>
                            <div class="review-form">
                                <div class="form-group">
                                    <label class="mb-0">{{$store.getters.t('need_contractor_review_modal_comment')}}</label>
                                    <textarea class="form-control" :placeholder="$store.getters.t('need_contractor_review_modal_enter_review_text')" v-model="$v.content.$model"></textarea>
                                    <div class="text-danger" v-if="$v.content.$error">{{$store.getters.t('need_contractor_review_modal_fill_field')}}</div>
                                </div>
                                <div class="form-group">
                                    <label class="mb-0">{{$store.getters.t('need_contractor_review_modal_files')}}</label>
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="files" accept="image/*" multiple @input="images = $event.target.files">
                                        <label class="custom-file-label" for="files">{{ images && images.length ? `${$store.getters.t('need_contractor_review_modal_selected_files')} ${images.length}` : $store.getters.t('need_contractor_review_modal_choose_files') }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around">
                                <button class="btn btn-lg btn-outline-white rounded py-3" data-dismiss="modal">{{$store.getters.t('need_contractor_review_modal_cancel')}}</button>
                                <button class="btn btn-lg btn-primary rounded py-3" @click.prevent="sendReview" :disabled="requestInProgress">{{$store.getters.t('need_contractor_review_modal_send')}}</button>
                            </div>
                        </template>
                        <template v-else>
                            <h2 class="text-center">{{$store.getters.t('need_contractor_review_modal_thanks_review_sent')}}</h2>
                        </template>
                    </div>
                    <!-- end /.modal-body -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'

export default {
    name: "NeedContractorReviewModal",
    computed: {
        currentUser() {
            return this.$store.getters.getUserData;
        }
    },
    data() {
        return {
            success: false,
            requestInProgress: false,
            mark: null,
            content: '',
            images: null
        }
    },
    mounted() {

    },
    methods: {
        sendCloseNeedReview() {
            if (!this.requestInProgress) {
                axios.post('/api/user/closeNeedReview');
            } else {
                this.requestInProgress = false;
            }
        },
        sendReview() {
            this.$v.$touch();

            if (this.$v.$error) return false;

            this.requestInProgress = true;

            const formData = new FormData();

            formData.append('expenditure_request_id', this.currentUser.need_review.expenditure_request_id);
            formData.append('contractor_id', this.currentUser.need_review.id);
            formData.append('content', this.content);
            formData.append('mark', this.mark);

            if (this.images) {
                Array.from(this.images).forEach(file => {
                    formData.append('images[]', file);
                });
            }

            axios.post('/api/contractor-reviews', formData, {
                header: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.success = true;
            }).catch(() => {
                this.requestInProgress = false;
            })
        }
    },
    watch: {
        'currentUser.need_review'(value) {
            console.log(value)
            if (this.currentUser.need_review) {
                const modal = $('#needReviewModal');

                modal.on('hide.bs.modal', () => {
                    this.sendCloseNeedReview();
                })

                modal.modal('show');
            }
        }
    },
    validations: {
        mark: {
            required
        },
        content: {
            required
        }
    }
}
</script>

<style lang="scss" scoped>
#needReviewComponent {
    .modal-logo {
        position: absolute;
        left: 50%;
        margin-left: -86px;
        top: -57px;
    }

    .modal-body {
        padding: 52px;
    }

    .close {
        position: absolute;
        right: 25px;
        top: 15px;
    }

    .title {
        font-size: 21px;
        line-height: 130%;
        text-align: center;
        margin: 0 auto;
    }

    .review-marks {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;

        .review-mark {
            transition: transform 400ms;
            cursor: pointer;

            svg {
                fill: #C4C4C4;
            }

            &:hover {
                transform: scale(1.3);

                svg {
                    fill: orangered;
                }

                .review-mark-name {
                    color: orangered;
                }
            }

            &.review-mark-active {
                svg {
                    fill: orangered;
                }

                .review-mark-name {
                    color: orangered;
                }
            }

            &-name {
                font-weight: 300;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
                color: #555555;
                margin-top: 5px;
            }

        }
    }

    .review-form {
        margin-top: 30px;
    }

    .modal-dialog {
        width: 510px;
        max-width: 510px;
    }

    .btn-outline-white {
        background: #fff;
        border: 1px solid #0674ec;
        color: #0674ec;
    }
}
</style>
